import { Injectable } from '@angular/core';
import { Platform, ToastController, LoadingController } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class UtilService {
  private loading: HTMLIonLoadingElement | null = null;

  constructor(private toastController: ToastController,
              private platform: Platform,
              private loadingController: LoadingController) {}


  isObjectEmpty(obj: any): boolean {
    if (obj) {
      return Object.keys(obj).length === 0;
    }
    return true;
  }
  
  isObjectNotEmpty(obj: any): boolean {
    if (obj) {
      return Object.keys(obj).length > 0;
    }
    return false;
  }

    /** Show a loading spinner */
    async showLoading(message: string = 'Please wait...') {
      if (this.loading) {
        return;
      }
      this.loading = await this.loadingController.create({
        message,
      });
      await this.loading.present();
    }

    /** Hide the loading spinner */
    async hideLoading() {
      if (this.loading) {
        await this.loading.dismiss();
        this.loading = null;
      }
    }

    /** Show an success message */
    async showSuccessMessage(message: string) {
      const toast = await this.toastController.create({
        message: message,
        duration: 3000, // Duration in milliseconds
        color: 'success', // Use a color to indicate an error message
      });
    
      toast.present();
    }


    /** Show an error message */
    async showErrorMessage(message: string) {
      const toast = await this.toastController.create({
        message: message,
        duration: 3000, // Duration in milliseconds
        color: 'danger', // Use a color to indicate an error message
      });
    
      toast.present();
    }


    isMobile() {
      return this.platform.is('mobile');
    }

}
